module.exports = __webpack_public_path__ + "media/images/menu-bf695b6874083e9b08401b2f747f908a.svg";